// This file was mostly generated by AI and then reviewed manually.
import {index} from '../requests/index_request'
import {backendSingularKind} from './record_keys'

const MISSING_ENTITY_INDEX_KINDS = new Set(['users', 'teams'])
const indexRequestByKind = new Map()
const unavailableEntities = new Set()

const addMissingReferencedIds = (missingIds, kind, allRecords) => {
	const fieldName = `${backendSingularKind(kind)}_id`
	const availableIds = new Set((allRecords[kind] || []).map(record => record.id))
	Object.values(allRecords).forEach(records => {
		records.forEach(record => {
			const id = record[fieldName]
			if (id && !availableIds.has(id)) missingIds.add(id)
		})
	})
}

export const canSuspendForMissingEntityIndex = kind => MISSING_ENTITY_INDEX_KINDS.has(kind)

export const resetMissingEntityIndex = () => {
	indexRequestByKind.clear()
	unavailableEntities.clear()
}

export const suspendForMissingEntityIndex = (kind, missingId, allRecords) => {
	let indexRequest = indexRequestByKind.get(kind)

	if (indexRequest?.error) {
		indexRequestByKind.delete(kind)
		throw indexRequest.error
	}
	const entityKey = `${kind}:${missingId}`
	if (unavailableEntities.has(entityKey)) return

	if (indexRequest) {
		addMissingReferencedIds(indexRequest.missingIds, kind, allRecords)
		throw indexRequest.promise
	}

	indexRequest = {missingIds: new Set([missingId])}
	addMissingReferencedIds(indexRequest.missingIds, kind, allRecords)
	indexRequest.promise = index(kind)
		.then(response => {
			if (indexRequestByKind.get(kind) !== indexRequest) return
			if (!response.ok) throw new Error(`Could not fetch ${kind}`)
			const returnedIds = new Set(response.items.map(record => record.id))
			indexRequest.missingIds.forEach(id => {
				const referencedEntityKey = `${kind}:${id}`
				if (returnedIds.has(id)) unavailableEntities.delete(referencedEntityKey)
				else unavailableEntities.add(referencedEntityKey)
			})
			indexRequestByKind.delete(kind)
		})
		.catch(error => {
			if (indexRequestByKind.get(kind) === indexRequest) indexRequest.error = error
		})
	indexRequestByKind.set(kind, indexRequest)

	throw indexRequest.promise
}
